import { openBlock as t, createElementBlock as r, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), r("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M12 20q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4q1.725 0 3.3.713A7.6 7.6 0 0 1 18 6.75V4h2v7h-7V9h4.2a5.84 5.84 0 0 0-2.187-2.2A5.93 5.93 0 0 0 12 6Q9.5 6 7.75 7.75T6 12t1.75 4.25T12 18a5.86 5.86 0 0 0 3.475-1.1A5.8 5.8 0 0 0 17.65 14h2.1q-.7 2.65-2.85 4.325T12 20"
    }, null, -1)
  ])]);
}
const h = { render: l };
export {
  h as default,
  l as render
};
